<template>
  <ResetPasswordModal
    v-if="modalActive"
    :modalMessage="modalMessage"
    @close-modal="handleClose"
  />
  <Loader v-if="isLoading" />
  <div class="row auth-row">
    <div class="col-12 col-lg-5 form-col">
      <p class="auth-already">
        Back to
        <span><router-link to="/login"> Login </router-link> </span>
      </p>
      <form>
        <p class="auth-header">Reset Password</p>
        <p class="auth-already">
          Forgot your passowrd? Enter your email to reset it
        </p>
        <div class="auth-field">
          <i class="fas fa-envelope auth-icon"></i>
          <input
            type="email"
            class="auth-input"
            placeholder="Email"
            v-model="email"
          />
        </div>
        <button type="submit" class="auth-button" @click.prevent="onSubmit">
          Reset
        </button>
      </form>
    </div>
    <div class="col-7 background-section"></div>
  </div>
</template>

<script>
import ResetPasswordModal from "../components/Modal.vue";
import Loader from "../components/Loader.vue";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "ResetPassword",
  components: {
    ResetPasswordModal,
    Loader,
  },
  data() {
    return {
      email: "",
      modalActive: false,
      modalMessage: "",
      isLoading: false,
    };
  },
  methods: {
    async onSubmit() {
      this.isLoading = true;
      try {
        await firebase.auth().sendPasswordResetEmail(this.email);
        this.modalActive = true;
        this.modalMessage = "Password reset link has been sent to your email.";
      } catch (error) {
        this.modalMessage = error.message;
        this.modalActive = true;
      } finally {
        this.isLoading = false;
      }
    },
    handleClose() {
      this.modalActive = false;
      this.email = "";
    },
  },
};
</script>

<style>
</style>